"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionViewType = void 0;
/**
 * 多维表视图类型
 */
var CollectionViewType;
(function (CollectionViewType) {
    CollectionViewType["TABLE"] = "table";
    CollectionViewType["BOARD"] = "board";
    CollectionViewType["SPACE"] = "space";
    CollectionViewType["GALLERY"] = "gallery";
    CollectionViewType["LIST"] = "list";
    CollectionViewType["TIMELINE"] = "timeline";
    CollectionViewType["CALENDAR"] = "calendar";
    CollectionViewType["FORM"] = "form";
})(CollectionViewType = exports.CollectionViewType || (exports.CollectionViewType = {}));
